<template>
    <div class="convention-push-header">
        <div>
            <typo name="title-30-normal">La veille juridique</typo>
            <sep name="S" />
            <typo v-if="hasPush" name="body-16-normal">
                Consulter les dernières veilles juridiques.
            </typo>
        </div>
        <div>
            <v-switch
                class="switch"
                v-model="alert"
                hide-details
                color="#0052FF"
                inset
                dense
                label="Recevoir la veille par email"
                :loading="loading"
                v-if="canSubscribe"
                :disabled="!hasConvention(convention)"
                @change="changeSubscription()"
            ></v-switch>
        </div>
    </div>
</template>

<script>
import userMixin from "src/mixins/user";
import { EventBus } from "src/bus/eventBus";
import { isArray } from "lodash";

export default {
    components: {},
    props: ["convention", "user", "pushes"],
    mixins: [userMixin],
    data() {
        return {
            alert: this.hasSubscribed(this.convention),
            loading: false,
        };
    },
    methods: {
        async changeSubscription() {
            this.loading = true;
            if (this.alert) {
                if (this.canSubscribeConvention) {
                    await this.updateConventionSubscription(this.convention, true);
                } else {
                    this.$nextTick(() => (this.alert = false));
                    EventBus.$emit("alert:error", {
                        message: "Vous avez atteint votre quota d'alertes email",
                        closable: false,
                    });
                }
            } else {
                await this.updateConventionSubscription(this.convention, false);
            }
            this.loading = false;
        },
    },
    computed: {
        hasPush() {
            return isArray(this.pushes) && this.pushes.length > 0;
        },
    },
    watch: {
        convention() {
            this.alert = this.hasSubscribed(this.convention);
        },
        user() {
            this.alert = this.hasSubscribed(this.convention);
        },
    },
};
</script>

<style scoped lang="sass">
.convention-push-header
    display: flex
    align-items: flex-start
    justify-content: space-between
</style>
